<template>
  <layout-content>
    <section v-if="!is_loading" class="d-flex">
      <template v-if="tree_menu.length > 0">
        <div class="b-tabs w-20">
          <services-menu :tree_menu="tree_menu" @selected_items="set_tab" />
        </div>
        <div class="b-tabs-contet w-100">
          <filter-component
            :type="current_tab"
            :current_trunks="current_trunks"
            :trunks_exist="trunks_exist"
          />
          <table-component :type="current_tab" />
        </div>
      </template>
      <template v-else>
        <empty-services />
      </template>
    </section>
  </layout-content>
</template>

<script>
  import ServicesMenu from '@prices/components/services-menu';
  import TableComponent from '@prices/components/table';
  import FilterComponent from '@prices/components/filter';
  import EmptyServices from '@prices/components/empty-services';
  import {
    SERVICES,
    getVoiceServicesMenu,
    getTemporaryVerificationServicesMenu,
    isVoiceService,
    isVoiceVerificationService,
    getFirstServiceName
  } from '@utils/services';
  import { mapGetters, mapActions } from 'vuex';
  import { RateService } from '@prices/services/RateService';
  import axios from 'axios';

  export default {
    components: {
      TableComponent,
      FilterComponent,
      ServicesMenu,
      EmptyServices
    },

    data: () => ({
      current_sub_item_id: null,
      is_loading: false,
      voice: {},
      verification: {},
      sms: {},
      hlr: {},
      tree_menu: [],
      current_trunks: []
    }),

    computed: {
      ...mapGetters('core/auth', ['user']),
      ...mapGetters('prices/rates/table', ['serviceName']),

      tabs: function () {
        return SERVICES;
      },

      current_tab: function () {
        return this.$route.params.type;
      },
      need_select_rate_id: function () {
        return isVoiceVerificationService(this.current_tab);
      },
      trunks_exist: function () {
        return isVoiceService(this.current_tab);
      }
    },

    watch: {
      current_tab: {
        handler: function (value) {
          this.setServiceName(value);

          if (this.trunks_exist) {
            this.setTrunks(this.tree_menu);
          }

          if (this.need_select_rate_id) {
            this.set_rate_id();
          } else {
            this.setSelectedRate(null);
          }
        },
        immediate: true
      }
    },

    created() {
      this.is_loading = true;
      this.setTrunks([]);
      this.setSelectedTrunk(null);

      this.$router.push({
        name: 'core.price.index'
      });

      axios
        .all([
          RateService.getServicesVoiceTrunks(),
          // RateService.getServicesVoiceVerificationTrunks()
          RateService.getServicesVoiceVerification(this.user.id)
        ])
        .then(
          axios.spread((voice, verification) => {
            this.voices = {
              name: 'voice',
              subPoints: getVoiceServicesMenu(voice)
            };

            /* у HLR и SMS не должно быть подобной конструкции, запрашиваем сразу прайсы */
            this.sms = {
              single: true,
              name: 'sms'
            };

            this.tree_menu = [this.voices, this.sms];

            if (this.$permission.module_hlr_is_allowed) {
              this.hlr = {
                single: true,
                name: 'hlr'
              };
              this.tree_menu = [...this.tree_menu, this.hlr];
            }
            this.verification = {
              name: 'number_verification',
              subPoints: getTemporaryVerificationServicesMenu(verification)
            };

            this.tree_menu = [...this.tree_menu, this.verification];

            this.setTrunks(this.tree_menu);
          })
        )
        .finally(() => (this.is_loading = false));
    },
    methods: {
      ...mapActions('prices/rates/table', [
        'setTrunks',
        'setServiceName',
        'setSelectedTrunk',
        'setSelectedRate'
      ]),

      set_rate_id: function () {
        let rate_id = this.verification.subPoints.find(
          (service) => service.name === this.current_tab
        )?.rate_id;

        if (rate_id) {
          this.setSelectedRate(rate_id);
        } else {
          this.setSelectedRate(null);
        }
      },

      set_tab: function (name) {
        if (this.current_tab !== name) {
          this.$router.replace({
            name: 'core.price.type',
            params: { type: name }
          });
        }
      }
    }
  };
</script>

<style lang="scss">
  .no-rates {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }
  section.d-flex {
    background: #fff;
    padding: 15px 15px;
  }

  .b-tabs {
    padding-right: 15px;

    &.w-20 {
      width: 360px;
    }

    .ivu-tabs-bar {
      border: none;
    }

    .ivu-tabs-nav-scroll {
      height: 100%;
    }

    .ivu-tabs-nav {
      float: none;

      .ivu-tabs-tab {
        display: block;

        &.ivu-tabs-tab-active,
        &.ivu-tabs-tab-focused {
          border-top: 1px solid #2196f3 !important;
          border-left: 1px solid #2196f3;
        }
      }
    }

    .ivu-tabs.ivu-tabs-card {
      & > .ivu-tabs-bar {
        height: 500px;

        .ivu-tabs-nav-container {
          height: 100%;
        }

        .ivu-tabs-tab {
          margin-bottom: 5px;
          border: 1px solid #dcdee2;
        }
      }
    }
  }
</style>
